import { Component, OnInit } from "@angular/core";
import { AttachmentsService } from "../../../services/attachments.service";
import * as moment from "moment";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Inject } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ConfirmDailogComponent } from "../shared/confirm-dailog/confirm-dailog.component";
import { parseFileName } from "../../../common/commonHelper";
@Component({
  selector: "app-attachments",
  templateUrl: "./attachments.component.html",
  styleUrls: ["./attachments.component.scss"],
})
export class AttachmentsComponent implements OnInit {
  constructor(
    private _attachementService: AttachmentsService,
    public dialogRef: MatDialogRef<AttachmentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _toaster: ToastrService,
    public dialog: MatDialog
  ) { }
  loadingVisible = false;
  ngOnInit(): void {
    if (this.data != undefined) {
      this.data = this.data.data?this.data.data:this.data
      this.mode = this.data["mode"];
      if (this.data["fileInfo"] != undefined) {
        this.fileInfo = this.data["fileInfo"].map((file) => ({
          ...file,
          isAudio: file.fileName.toLowerCase().endsWith(".m4a"),
        }));
      }
    }
  }
  mode;
  selectedFiles: FileList;
  currentFile: File;
  uploadedFiles: File[] = [];
  validFileExt: Array<string> = [
    ".jpg",
    ".jpeg",
    ".png",
    ".pdf",
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".txt",
    ".tiff",
    ".zip",
    ".gif",
    ".m4a"
  ];
  selectedFile;
  selectFile(event): void {
    this.selectedFiles = event.target.files;
    this.selectedFile = event.target.files[0];
    const filename = this.selectedFile.name;
    const filesize = this.selectedFile.size / (1024 * 1024); // Convert to MB
    const fileExt = filename.substring(filename.lastIndexOf("."), filename.length).toLowerCase();
    const fileType = this.selectedFile.type;
  
    if (!this.validFileExt.includes(fileExt)) {
      this._toaster.error(
        "Invalid file type. Allowed extensions: " + this.validFileExt.join(", "),
        "Failed",
        { timeOut: 1000, closeButton: true }
      );
    } else if (filesize > 25) {
      this._toaster.error("File size cannot be larger than 25MB!", "Failed", {
        timeOut: 1000,
      });
    } else {
      const isAudio = fileType.startsWith("audio/");
      const fileUrl = URL.createObjectURL(this.selectedFile); 
      this.fileInfo.push({
        fileName: filename,
        fileSize: filesize.toFixed(2), 
        fileUrl: fileUrl, 
        createdDate: moment(new Date()).format("MM/DD/YYYY"),
        modifiedDate: moment(new Date()).format("MM/DD/YYYY"),
        isAudio: isAudio,
        isUploading: true,
      });
  
      this.upload(); 
    }
  }
  


  fileInfo = [];
  attachmentData = {};
  filesChanged = false;
  closePopup() {
    this.attachmentData["fileInfo"] = this.fileInfo;
    this.attachmentData["filesChanged"] = this.filesChanged;
    this.attachmentData["uploadedFiles"] = this.uploadedFiles;
    this.attachmentData["model"] = this.data["model"];
    this.dialogRef.close(this.attachmentData);
  }

  upload(): void {
    this.currentFile = this.selectedFiles.item(0);
    const formData: FormData = new FormData();
  
    formData.append("file", this.currentFile, parseFileName(this.currentFile.name));
    this.loadingVisible = true;
  
    const companyName = localStorage
      .getItem("selectedCompanyName")
      .toLowerCase()
      .split(" ")
      .join("_");
    const formName = this.data["model"];
  
    this._attachementService.uploadNew(companyName, formName, formData).then(
      (response) => {
        this.loadingVisible = false;
        if (response.status === "success") {
          this.filesChanged = true;
  
          const index = this.fileInfo.findIndex(
            (file) => file.fileName === this.currentFile.name
          );
          if (index > -1) {
            this.fileInfo[index] = {
              fileName: response.fileName,
              fileUrl: response.fileUrl, 
              fileSize: response.fileSize,
              createdDate: moment(response.createdDate).format("MM/DD/YYYY"),
              modifiedDate: moment(response.modifiedDate).format("MM/DD/YYYY"),
              isAudio: response.fileName.toLowerCase().endsWith(".m4a"), 
            };
          }
        }
      },
      (err) => {
        this.loadingVisible = false;
        this._toaster.error("Failed to upload file. Please try again.", "Error");
  
        this.fileInfo = this.fileInfo.filter(
          (file) => file.fileName !== this.currentFile.name
        );
      }
    );
    this.selectedFiles = undefined;
  }
  
  deleteFile(fileName) {
    let companyName = localStorage
      .getItem("selectedCompanyName")
      .toLowerCase()
      .split(" ")
      .join("_");
    let formName = this.data["model"];
    this.fileInfo.forEach((item, index) => {
      if (item.fileName === fileName) this.fileInfo.splice(index, 1);

      this._attachementService
        .deleteFile(companyName, formName, fileName)
        .subscribe(
          (response) => {
            console.log(response);
            if (response.status === "success") {
              this.filesChanged = true;
            }
          },
          (err) => { }
        );
    });

    this.selectedFiles = undefined;
    console.log(this.fileInfo);
  }
  
  activeAudioIndex: number | null = null;
  getFileUrl(fileUrl: string): string {
    return fileUrl.replace('https://', 'http://');
  }
  onPlay(index: number): void {
    
    if (this.activeAudioIndex !== null && this.activeAudioIndex !== index) {
      const previousAudio = document.getElementById(`audio-${this.activeAudioIndex}`) as HTMLAudioElement;
      if (previousAudio) {
        previousAudio.pause();
      }
    }
    this.activeAudioIndex = index; 
  }

  onPause(index: number): void {
    if (this.activeAudioIndex === index) {
      this.activeAudioIndex = null; 
    }
  }

  onAudioError(index: number): void {
    console.error(`Error loading audio file at index ${index}:`, this.fileInfo[index].fileUrl);
    alert('Unable to play this audio file. Please check the file format and try again.');
  }
  
  confirmDelete(fileName): void {
    const dialogData = {};
    dialogData["title"] = "Confirm Delete";
    dialogData["message"] = "Are you sure you want to delete the attachment?";

    const dialogRef = this.dialog.open(ConfirmDailogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.deleteFile(fileName);
      }
    });
  }
}
